module.exports = __webpack_public_path__ + "static/nec_eng-4fc13bab8f28f429494afbdcfe6e6762.png";